// extracted by mini-css-extract-plugin
module.exports = {"dataLabel":"VerboseStationInfo-module__dataLabel___2JlBx"};